import $ from "jquery";

$('.ui.multilingual-tabs>.menu>.item').tab();